import { videoTemplate } from "../../shortcodes/templates";
import { sendToServer } from "@/utility/mediaObjectUploadHelper";
import { getFirstVideoFrame } from "@/utility/getFirstVideoFrame";

const insertVideoConfig = {
  title: "Insert video file",
  body: {
    type: "panel",
    name: "hrLineValue",
    items: [
      {
        name: "video",
        type: "htmlpanel",
        html: videoTemplate,
      },
    ],
  },
  buttons: [
    {
      type: "cancel",
      name: "closeButton",
      text: "Cancel",
    },
    {
      type: "submit",
      name: "submitButton",
      text: "Insert",
      primary: true,
    },
  ],
  onSubmit: async function (api) {
    const inputEl = document.getElementById("video-file-input");
    const file = inputEl.files?.[0];

    if (file) {
      try {
        const videoUploaded = await sendToServer(file);
        // Create a file from the first frame
        const firstFrame = await getFirstVideoFrame(file);
        const thumbnailImageFile = await fetch(firstFrame).then(res => res.blob());
        const thumbnailImage = await sendToServer(thumbnailImageFile);

        // eslint-disable-next-line no-undef
        tinymce.activeEditor.execCommand(
          "mceInsertContent",
          false,
          `
        <video src="${videoUploaded["@id"]}" controls playsinline webkit-playsinline poster="${thumbnailImage["@id"]}">
        </video>
      `,
        );
      } catch (e) {
        console.log(e);
      }
    }
    // eslint-disable-next-line no-undef
    api.close();
  },
};

export { insertVideoConfig };
